module.exports = __webpack_public_path__ + "statics/img/cate6-1@2x.86d04d52.png";